import { h, Fragment } from 'preact'
import { useEffect, useState, useRef } from 'preact/hooks'
import DayPicker from 'react-day-picker'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import MaskedInput from 'react-input-mask'
import 'react-day-picker/lib/style.css'
import * as style from './date-picker.css'
import { DATE_FORMAT } from '../../shared/const'

const MASK = '99/99/9999'

interface Props {
    id: string
    placeholder?: string
    value?: string
    isFocused?: boolean
    onFocus: () => void
    onChange: (day: string) => void
    hidePicker?: boolean
}

const DatePicker: preact.FunctionalComponent<Props> = (props) => {
    const { id, value, placeholder, isFocused, onFocus, onChange, hidePicker } = props
    const inputRef = useRef(null)
    const [isOpen, openDatePicker] = useState<boolean>(false)

    useEffect(() => {
        if (!isFocused) {
            openDatePicker(false)
        }
    }, [isFocused])

    const formatDate = (date: Date, format: string = DATE_FORMAT): string => {
        if (!date || !(date instanceof Date)) {
            return ''
        }

        dayjs.extend(customParseFormat)
        return dayjs(date).format(format)
    }

    const parseDate = (str: string, format: string = DATE_FORMAT): Date | undefined => {
        if (!str) {
            return
        }

        const parsed = dayjs(str, format).toDate()

        if (formatDate(parsed) === str) {
            return parsed
        }

        return
    }

    const parsedDate = parseDate(value as string)

    return (
        <div class={style.datePickerWrapper}>
            <MaskedInput
                mask={MASK}
                value={value}
                onFocus={() => {
                    openDatePicker(true)
                    onFocus()
                }}
                onBlur={() => {
                    setTimeout(() => {
                        if (inputRef instanceof HTMLInputElement && isFocused) {
                            openDatePicker(true)
                        }
                    }, 0)
                }}
                onChange={(event: any) => {
                    const { value: targetValue } = event.target as HTMLInputElement
                    if (targetValue === '__/__/____') {
                        onChange('')
                    } else {
                        onChange(targetValue)
                    }
                }}
            >
                {() => (
                    <input
                        id={id}
                        placeholder={placeholder || DATE_FORMAT}
                        className={style.datePickerInput}
                        ref={inputRef}
                        onClick={() => {
                            if (!isOpen) {
                                openDatePicker(true)
                            }
                        }}
                    />
                )}
            </MaskedInput>

            {!hidePicker && (
                <Fragment>
                    <span
                        class={style.datePickerIcon}
                        onClick={() => {
                            openDatePicker(true)
                            onFocus()
                        }}
                    >
                        date_range
                    </span>

                    {isOpen && (
                        <div class={style.datePickerOverlay}>
                            <div class={style.datePickerClose} onClick={() => openDatePicker(false)} />
                            <DayPicker
                                disabledDays={[{ after: new Date() }]}
                                month={parsedDate}
                                selectedDays={parsedDate}
                                onDayClick={(date, dayOption) => {
                                    if (dayOption.disabled) {
                                        return
                                    }
                                    openDatePicker(false)
                                    return onChange && onChange(formatDate(date))
                                }}
                            />
                        </div>
                    )}
                </Fragment>
            )}
        </div>
    )
}

export default DatePicker
